import { PRELOAD_DATA } from '../../../car/dataPreload/store/preload.action-types';
import { RESET_STATE } from '../../../wizard/store/wizard.action-types';
import { BIRTHDATE_SAVE } from './birthdate.action-types';

const INITIAL_STATE = {
  selected: null,
};

const birthdateReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PRELOAD_DATA:
      return reduceWithBirthdate(state, action.payload.person?.birthdate);
    case RESET_STATE:
      return {
        ...state,
        selected: null,
      };
    case BIRTHDATE_SAVE:
      return reduceWithBirthdate(state, action.payload);
    default:
      return state;
  }
};

const reduceWithBirthdate = (state, birthdate) => {
  return { ...state, selected: birthdate };
};

export default birthdateReducer;
